/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TTLORouteLocationRequest,
    TTLORouteLocationRequestFromJSON,
    TTLORouteLocationRequestFromJSONTyped,
    TTLORouteLocationRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOCriteriaForRouteRequest
 */
export interface TTLOCriteriaForRouteRequest {
    /**
     * 
     * @type {TTLORouteLocationRequest}
     * @memberof TTLOCriteriaForRouteRequest
     */
    from?: TTLORouteLocationRequest;
    /**
     * 
     * @type {TTLORouteLocationRequest}
     * @memberof TTLOCriteriaForRouteRequest
     */
    to?: TTLORouteLocationRequest;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOCriteriaForRouteRequest
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOCriteriaForRouteRequest
     */
    isOutbound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOCriteriaForRouteRequest
     */
    match?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TTLOCriteriaForRouteRequest
     */
    order?: number;
}

export function TTLOCriteriaForRouteRequestFromJSON(json: any): TTLOCriteriaForRouteRequest {
    return TTLOCriteriaForRouteRequestFromJSONTyped(json, false);
}

export function TTLOCriteriaForRouteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOCriteriaForRouteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : TTLORouteLocationRequestFromJSON(json['from']),
        'to': !exists(json, 'to') ? undefined : TTLORouteLocationRequestFromJSON(json['to']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
        'match': !exists(json, 'match') ? undefined : json['match'],
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}

export function TTLOCriteriaForRouteRequestToJSON(value?: TTLOCriteriaForRouteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': TTLORouteLocationRequestToJSON(value.from),
        'to': TTLORouteLocationRequestToJSON(value.to),
        'exclude': value.exclude,
        'isOutbound': value.isOutbound,
        'match': value.match,
        'order': value.order,
    };
}


